/* eslint-disable */

import React, { Component } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  TextField,
  Typography,
  useMediaQuery,
  Tooltip,
  Alert,
  RadioGroup,
  Radio,
  FormLabel,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Autocomplete,
  Popper,
  CircularProgress,
} from '@mui/material';
import { CheckCircle, Info } from '@mui/icons-material';
import AuthServices from '../services/auth';
import { CountryCodes } from './CountryCodes';
import { DatePicker } from 'antd';
import moment from 'moment';
import { AsYouType } from 'libphonenumber-js';
import localAuthServices from '../localAuthServices';

class ChangeDetailsForm extends Component {
  constructor(props) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    var pair1 = vars[0].split("=");
    super(props);
    this.state = {
      country_code: '',
      nationality: '',
      dob: '',
      address: '',
      gender: '',
      alertType: '',
      apiMessage: '',
      registerState: true,
      investor_email: null,
      confirm: false,
      data: {},
      containLetter: false,
      containNumber: false,
      containSpecial: false,
      minLength: false,
      currentDetails: {},
      loading: true,
      sourceDomain: pair1[1]
    };
    this.myRef = React.createRef()
  }

  componentDidMount() {
    localAuthServices.refreshTokenOnLoad().then(() => {
      AuthServices.getUserData({}, apiData => {
        if (apiData.status) {
          this.setState({
            ...this.state,
            currentDetails: apiData.data,
            country_code: this.getCountryCode(apiData.data.phone_number),
            nationality: apiData.data.nationality,
            dob: apiData.data.dob,
            address: apiData.data.mailing_address,
            gender: apiData.data.gender,
            loading: false
          });
          this.getCountryCodeIndex(apiData.data.phone_number)
        }
      })
    })

  }

  getCountryCode(input) {
    const defaultCountryCode = input.substr(0, 1) !== '+' ? 'MSIA' : null;
    let formatted = new AsYouType(defaultCountryCode).input(input);
    let countryCode = '';

    if (defaultCountryCode === 'MSIA') {
      countryCode = '+60';
    }
    else {
      const parts = formatted.split(' ');
      countryCode = parts.length > 1 ? parts.shift() : '';
    }

    return countryCode
  }

  getCountryCodeIndex(phone) {
    let countryCode = this.getCountryCode(phone)
    let index = CountryCodes.countries.findIndex(x => x.dial_code === countryCode);
    return index
  }

  getPhoneNumber(phone) {
    let countryCode = this.getCountryCode(phone)
    let trimmed = phone.replace(countryCode, '')
    return trimmed;
  }

  getNationalityIndex(nationality) {
    let index = CountryCodes.countries.findIndex(x => x.name === nationality);
    return index
  }

  handleEmailChanged = (e) => {
    e.target.value = e.target.value.trim()
  }

  cancelSubmit = () => {
    this.setState({
      ...this.state,
      confirm: false
    })
  }

  confirmSubmit = async () => {
    let _code = this.state.country_code;
    let _data = this.state.data;
    let _finalData;
    let service = 2;
    if (this.state.sourceDomain == 'https://events.icapital.biz'){
      service = 3
    }
    Object.keys(_data).map(() => {
      _finalData = {
        ..._data,
        phone_number: _code + _data['phone_number'],
        gender: _data['gender'],
        nationality: this.state.nationality,
        dob: this.state.dob,
        mailing_address: _data['mailing_address'],
        service: service
      };
      return _finalData;
    });
    this.setState({
      ...this.state,
      investor_email: _data['email']
    });
    try {
      var response = await AuthServices.changeDetails(_finalData)
      if (response.status) {
        this.setState({
          ...this.state,
          registerState: false,
          confirm: false,
          country_code: ''
        });
      }
      else this.myRef.current.scrollIntoView({ block: 'center' })
    } catch (e) {
      let error = e.response.data.message;
      this.setState({
        ...this.state,
        confirm: false,
        alertType: 'error',
        apiMessage: error
      });
    }
  }

  checkUsername = () => {
    let _username = document.querySelector('input[name="username"]');
    let _usernameParent = document.querySelector('div.username_container');
    let _hintLabel = document.querySelectorAll('label')[1];
    let _hintText = document.getElementById('username_regex');
    _hintText.style.display = 'none';
    let _parentClasses = _usernameParent.classList;
    _parentClasses.remove('Mui-error');
    _hintLabel.classList.remove('Mui-error');
    var _usernameRegex = new RegExp(
      '^([a-zA-Z])([._-]*|[a-zA-Z0-9]){5,18}([._-]*|[a-zA-Z0-9])$'
    );

    if (_username.value != '') {
      if (
        !_usernameRegex.test(_username.value) ||
        _username.value.length < 5 ||
        _username.value.length > 18
      ) {
        _parentClasses.add('Mui-error');
        _hintLabel.classList.add('Mui-error');
        _hintText.style.display = 'block';
        return false;
      } else {
        _parentClasses.remove('Mui-error');
        _hintLabel.classList.remove('Mui-error');
        _hintText.style.display = 'none';
        return true;
      }
    }
  };

  checkPhoneNumber = () => {
    let _phoneNumber = document.querySelector('input[name="phone_number"]');
    let _phoneNumberParent = document.querySelector(
      'div.phone_number_container'
    );
    let _hintLabel = document.querySelector('.phoneNumber > label');
    let _hintText = document.getElementById('phoneNumberRegex');
    _hintText.style.display = 'none';
    let _parentClasses = _phoneNumberParent.classList;
    _parentClasses.remove('Mui-error');
    _hintLabel.classList.remove('Mui-error');
    var _phoneNumberRegex = new RegExp('[0-9]');

    if (_phoneNumber.value != '') {
      if (
        !_phoneNumberRegex.test(_phoneNumber.value) ||
        _phoneNumber.value.length < 6 ||
        _phoneNumber.value.length > 20
      ) {
        _parentClasses.add('Mui-error');
        _hintLabel.classList.add('Mui-error');
        _hintText.style.display = 'block';
      } else {
        _parentClasses.remove('Mui-error');
        _hintLabel.classList.remove('Mui-error');
        _hintText.style.display = 'none';
      }
    }
  };

  handlePhoneOTP = event => {
    const phoneNumberVal = event.target.value;
    if (phoneNumberVal !== '') {
      console.log('not empty');
    } else {
      console.log('empty');
    }
  };

  render() {
    const { isSmallScreen } = this.props;

    const handleSelectChange = (event, value) => {
      this.setState({
        ...this.state,
        country_code: value.dial_code
      });
    };

    const handleNationalityChange = (event, value) => {
      this.setState({
        ...this.state,
        nationality: value.name
      });
    };

    const handleAddress = event => {
      this.setState({
        ...this.state,
        address: event.target.value
      });
    };

    const handleDOB = (date, dateString) => {
      this.setState({
        ...this.state,
        dob: dateString
      });
    };

    const options = CountryCodes.countries.map((option) => {
      const firstLetter = option.name[0].toUpperCase();
      return {
        firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
        ...option,
      };
    });

    function PasswordException() { }

    PasswordException.prototype = new Error();

    const PopperMy = function (props) {
      return <Popper {...props} style={{ width: "fit-content" }} placement="bottom-start" />;
    };

    const disabledDate = (current) => {
      return current > moment().subtract(18, 'year');
    };

    const closeWindow = () => {
      AuthServices.getUserData({}, apiData => {
        if (apiData.status) {
          window.opener.postMessage({
            event_id: "change_details",
            user: apiData.data
          }, this.state.sourceDomain);
          setTimeout(function () {
            window.self.close();
          }, 3000);
        }
      })
    }

    return (

      <>
        {this.state.registerState ?
          <>
            <div ref={this.myRef}></div>
            <Grid
              container
              spacing={0}
              direction="column"
              alignItems="center"
              justifyContent="center"
              style={{ minHeight: '100vh' }}
            >
              <Grid item xs={3}>
                {this.state.loading ?
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    style={{ minHeight: '100vh' }}
                  >
                    <CircularProgress />
                  </Grid>
                  :
                  <Grid
                    container
                    spacing={0}
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    style={{ minHeight: '100vh' }}
                  >
                    <Grid item xs={12} md={6} className='logoContainer'
                      textAlign="center">
                      <Box className='registerBackground'>
                        <img src='/logo_black.png' alt="iCapital" className='registerLogo' />
                      </Box>
                    </Grid>

                    <Grid item xs={11} md={6} className="displayBoxBorder">
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                      >
                        <Box>
                          <Typography
                            variant="h4"
                            align="left"
                          >
                            <b>CHANGE ACCOUNT DETAILS</b>
                          </Typography>
                        </Box>
                        {this.state.apiMessage != '' && (
                          <Box mb={3}>
                            <Alert severity={this.state.alertType}>
                              {this.state.apiMessage}
                            </Alert>
                          </Box>
                        )}
                        <Box>
                          <Formik
                            initialValues={{
                              email: this.state.currentDetails.email,
                              username: this.state.currentDetails.username,
                              full_name: this.state.currentDetails.full_name,
                              country_code: this.getCountryCode(this.state.currentDetails.phone_number),
                              phone_number: this.getPhoneNumber(this.state.currentDetails.phone_number),
                              gender: this.state.currentDetails.gender,
                              nationality: this.state.currentDetails.nationality,
                              dob: this.state.currentDetails.dob,
                              mailing_address: this.state.currentDetails.mailing_address,
                            }}
                            validationSchema={Yup.object().shape({
                              email: Yup.string()
                                .email('Must be a valid email address')
                                .max(50)
                                .required('Email is required'),
                              username: Yup.string()
                                .max(18)
                                .required('Username is required'),
                              full_name: Yup.string()
                                .max(50)
                                .required('Full name is required'),
                              phone_number: Yup.number().required(
                                'Phone number is required'
                              ),
                              gender: Yup.string().required('Gender is required'),
                              mailing_address: Yup.string().required('Mailing address is required'),
                            })}
                            onSubmit={async data => {
                              try {
                                if (this.checkUsername()) {
                                  this.setState({
                                    ...this.state,
                                    data: data,
                                    confirm: true
                                  });
                                }
                                else this.myRef.current.scrollIntoView({ block: 'center' })
                              } catch (e) {
                                console.log(e)
                              }
                            }}
                          >
                            {({
                              errors,
                              handleBlur,
                              handleChange,
                              handleSubmit,
                              isSubmitting,
                              touched
                            }) => (
                              <form onSubmit={handleSubmit}>
                                <Grid
                                  container
                                  columnSpacing={5}
                                  rowSpacing={0}
                                  direction="row"
                                  alignItems="center"
                                  justifyContent="center"
                                >
                                  <Grid item xs={12} md={12}>
                                    <Box
                                      display="flex"
                                      flexDirection="row"
                                      position="relative"
                                    >
                                      <TextField
                                        defaultValue={this.state.currentDetails.full_name}
                                        error={Boolean(
                                          touched.full_name && errors.full_name
                                        )}
                                        fullWidth
                                        helperText={
                                          touched.full_name && errors.full_name
                                        }
                                        label={'Full name as per ID'}
                                        placeholder="eg. John Smith"
                                        margin="normal"
                                        name="full_name"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        variant="standard"
                                      />
                                      <Tooltip
                                        title={'Your fullname cannot be changed once your account has been created.'}
                                        placement={isSmallScreen ? "left" : "bottom"}>
                                        <Info className="tooltipStyle" />
                                      </Tooltip>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <Box
                                      display="flex"
                                      flexDirection="row"
                                      position="relative"
                                    >
                                      <TextField
                                        defaultValue={this.state.currentDetails.email}
                                        error={Boolean(touched.email && errors.email)}
                                        fullWidth
                                        helperText={touched.email && errors.email}
                                        label={'Email address'}
                                        placeholder="eg. johnsmith@gmail.com"
                                        margin="normal"
                                        name="email"
                                        onBlur={handleBlur}
                                        onChange={(e) => { this.handleEmailChanged(e); handleChange(e) }}
                                        type="text"
                                        variant="standard"
                                      />
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} md={6}>
                                    <Box
                                      display="flex"
                                      flexDirection="row"
                                      position="relative"
                                    >
                                      <FormControl
                                        fullWidth
                                        margin="normal"
                                        variant="outlined"
                                      >
                                        <InputLabel
                                          className={
                                            touched.username && errors.username
                                              ? 'Mui-error'
                                              : ''
                                          }
                                          htmlFor="outlined-adornment-username"
                                        >
                                        </InputLabel>
                                        <TextField
                                          defaultValue={this.state.currentDetails.username}
                                          error={Boolean(
                                            touched.username && errors.username
                                          )}
                                          variant='standard'
                                          id="outlined-adornment-username"
                                          name="username"
                                          className="username_container"
                                          onBlur={handleBlur}
                                          onChange={handleChange}
                                          onKeyUp={this.checkUsername}
                                          label="Username"
                                          aria-describedby="username-helper-text"
                                        />
                                        <p id="username_regex" className="Mui-error">
                                          {'Username should be at least 5 or at most 18 characters long, cannot contain whitespace(" ") and can only use letters, numbers and limited special characters like period("."), dash("-") or underscore("_")'}
                                        </p>
                                        {touched.username && errors.username && (
                                          <FormHelperText
                                            className={
                                              touched.username && errors.username
                                                ? 'Mui-error'
                                                : ''
                                            }
                                            id="username-helper-text"
                                          >
                                            {'Username is required'}
                                          </FormHelperText>
                                        )}
                                      </FormControl>
                                      <Tooltip
                                        title={'You can use letters, numbers and certain limited special characters like period("."), dash("-") or underscore("_") in your username. Whitespace (" ") is not allowed. Please remember your username to login to Capital Dynamics\' websites.'}
                                        placement={isSmallScreen ? "left" : "bottom"}>
                                        <Info className="tooltipStyle" />
                                      </Tooltip>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} md={12}>
                                    <Box
                                      display="flex"
                                      flexDirection="row"
                                      position="relative"
                                    >
                                      <Grid className="phoneContainer" sx={{ flexGrow: 1 }}>
                                        <Grid className="phoneCode">
                                          <Autocomplete
                                            defaultValue={CountryCodes.countries[this.getCountryCodeIndex(this.state.currentDetails.phone_number)]}
                                            size='small'
                                            disableClearable
                                            popupIcon={<></>}
                                            PopperComponent={PopperMy}
                                            onChange={handleSelectChange}
                                            options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                                            groupBy={(option) => option.firstLetter}
                                            getOptionLabel={(option) => option.dial_code + ' ' + option.name}
                                            renderInput={(params) => <TextField {...params} label="Dial Code" />}
                                            isOptionEqualToValue={(option, value) => option.dial_code === value.dial_code}
                                            sx={{ width: '100%' }}
                                          />
                                          {touched.country_code &&
                                            this.state.country_code == '' &&
                                            isSubmitting == false && (
                                              <FormHelperText
                                                className={
                                                  touched.country_code &&
                                                    this.state.country_code == ''
                                                    ? 'Mui-error'
                                                    : ''
                                                }
                                                id="country-code-helper-text"
                                              >
                                                {'Dial code is required'}
                                              </FormHelperText>
                                            )}
                                        </Grid>
                                        <FormControl
                                          margin="normal"
                                          variant="outlined"
                                          className="phoneNumber"
                                        >
                                          <InputLabel
                                            className={
                                              touched.phone_number && errors.phone_number
                                                ? 'Mui-error'
                                                : ''
                                            }
                                            htmlFor="outlined-adornment-phone-number"
                                          >
                                          </InputLabel>
                                          <TextField
                                            defaultValue={this.getPhoneNumber(this.state.currentDetails.phone_number)}
                                            error={Boolean(
                                              touched.phone_number && errors.phone_number
                                            )}
                                            id="outlined-adornment-phone-number"
                                            name="phone_number"
                                            placeholder="eg. 123456789"
                                            className="phone_number_container"
                                            onBlur={handleBlur}
                                            onChange={event => {
                                              handleChange(event);
                                              this.handlePhoneOTP(event);
                                            }}
                                            onKeyUp={this.checkPhoneNumber}
                                            label="Phone Number"
                                            aria-describedby="phone-number-helper-text"
                                            type="number"
                                            variant="standard"
                                          />
                                          <p id="phoneNumberRegex" className="Mui-error">
                                            {'Must be a valid phone number'}
                                          </p>
                                          {touched.phone_number && errors.phone_number && (
                                            <FormHelperText
                                              className={
                                                touched.phone_number &&
                                                  errors.phone_number
                                                  ? 'Mui-error'
                                                  : ''
                                              }
                                              id="phone-number-helper-text"
                                            >
                                              {'Phone number is required'}
                                            </FormHelperText>
                                          )}
                                        </FormControl>
                                      </Grid>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} md={4}>
                                    <Box
                                      display="flex"
                                      flexDirection="row"
                                      position="relative"
                                    >
                                      <FormControl sx={{ marginTop: '10px' }} >
                                        <FormLabel >Gender</FormLabel>
                                        <RadioGroup
                                          defaultValue={this.state.gender}
                                          onChange={handleChange}
                                        >
                                          <FormControlLabel
                                            defaultChecked={this.state.gender === "F"} name="gender" value="F" control={<Radio />} label="Female" />
                                          <FormControlLabel
                                            defaultChecked={this.state.gender === "M"} name="gender" value="M" control={<Radio />} label="Male" />
                                        </RadioGroup>
                                        {touched.gender && errors.gender && (
                                          <FormHelperText
                                            className={touched.gender && errors.gender
                                              ? 'Mui-error'
                                              : ''
                                            }
                                            id="gender-helper-text"
                                          >
                                            {'Gender is required'}
                                          </FormHelperText>
                                        )}
                                      </FormControl>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={12} md={8}>
                                    <Grid
                                      container
                                      direction="column"
                                      justifyContent="space-around"
                                      alignItems="stretch"
                                    >
                                      <Grid item xs={12}>
                                        <FormControl variant="standard" sx={{ minWidth: '100%', marginBottom: '15px', marginTop: '15px' }}>
                                          <Autocomplete
                                            defaultValue={CountryCodes.countries[this.getNationalityIndex(this.state.currentDetails.nationality)]}
                                            size='small'
                                            disableClearable
                                            popupIcon={<></>}
                                            PopperComponent={PopperMy}
                                            onChange={handleNationalityChange}
                                            options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                                            groupBy={(option) => option.firstLetter}
                                            getOptionLabel={(option) => option.name}
                                            renderInput={(params) => <TextField {...params} label="Nationality" />}
                                            isOptionEqualToValue={(option, value) => option.name === value.name}
                                            sx={{ width: '100%' }}
                                          />
                                          {touched.nationality &&
                                            this.state.nationality == '' &&
                                            isSubmitting == false && (
                                              <FormHelperText
                                                className={
                                                  touched.nationality &&
                                                    this.state.nationality == ''
                                                    ? 'Mui-error'
                                                    : ''
                                                }
                                                id="nationality-helper-text"
                                              >
                                                {'Nationality is required'}
                                              </FormHelperText>
                                            )}
                                        </FormControl>
                                      </Grid>
                                      <Grid item xs={12}>
                                        <InputLabel>Date of Birth</InputLabel>
                                        <DatePicker
                                          defaultValue={moment(this.state.dob)}
                                          name="dob"
                                          disabledDate={disabledDate}
                                          defaultPickerValue={moment().subtract(18, 'years')}
                                          onChange={handleDOB}
                                          style={{ width: '100%' }}
                                        />
                                        {touched.dob &&
                                          this.state.dob == '' &&
                                          isSubmitting == false && (
                                            <FormHelperText
                                              className={
                                                touched.dob &&
                                                  this.state.dob == ''
                                                  ? 'Mui-error'
                                                  : ''
                                              }
                                              id="dob-helper-text"
                                            >
                                              {'Date of Birth is required'}
                                            </FormHelperText>
                                          )}
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12}>
                                    <FormControl variant="standard" sx={{ minWidth: '100%', marginTop: '15px' }} name="mailing_address">
                                      <TextField
                                        defaultValue={this.state.address}
                                        name="mailing_address"
                                        label="Mailing Address"
                                        multiline
                                        maxRows={3}
                                        onChange={handleChange}
                                        variant="standard"
                                        error={Boolean(
                                          touched.mailing_address && errors.mailing_address
                                        )}
                                      />
                                      {errors.mailing_address && (
                                        <FormHelperText
                                          className={touched.mailing_address && errors.mailing_address
                                            ? 'Mui-error'
                                            : ''
                                          }
                                          id="mailing_address-helper-text"
                                        >
                                          {'Mailing address is required'}
                                        </FormHelperText>
                                      )}
                                    </FormControl>
                                  </Grid>
                                </Grid>
                                <Box my={2}>
                                  <Button
                                    color="primary"
                                    disabled={isSubmitting}
                                    fullWidth
                                    size="large"
                                    type="submit"
                                    variant="contained"
                                  >
                                    {'Confirm'}
                                  </Button>
                                </Box>
                              </form>
                            )}
                          </Formik>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>}
              </Grid>
            </Grid>
            <Dialog
              open={this.state.confirm}
              onClose={this.cancelSubmit}
            >
              <DialogTitle id="alert-dialog-title">
                {"Confirm Personal details"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description" sx={{ whiteSpace: 'pre-line' }}>
                  Full Name: {this.state.data.full_name + '\n'}
                  Email Address: {this.state.data.email + '\n'}
                  Username: {this.state.data.username + '\n'}
                  Phone Number: {this.state.country_code + this.state.data['phone_number'] + '\n'}
                  Gender: {this.state.data['gender'] + '\n'}
                  Nationality: {this.state.nationality + '\n'}
                  Date of Birth: {this.state.dob + '\n'}
                  Mailing Address: {this.state.data['mailing_address']}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.cancelSubmit}>Change Details</Button>
                <Button onClick={this.confirmSubmit} autoFocus>
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>
          </>
          :
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ minHeight: '100vh' }}
          >
            <Grid item xs={12} md={3}>
              <Card>
                <CardContent sx={{ textAlign: "center" }}>
                  <img src='/logo.png' alt="iCapital" width="50%" height="auto" />
                  <br />
                  <CheckCircle color='success' sx={{ fontSize: "100px", marginBottom: "30px" }} />
                  <Typography>
                    You have successfully updated your Capital Dynamics account details.
                    <br />
                    This page will close in a few seconds
                  </Typography>
                  <Box sx={{ display: "none" }}>
                    {closeWindow()}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        }
      </>
    );
  }
}

export default function Register() {
  const navigator = useNavigate();
  const isSmallScreen = useMediaQuery('(max-width:620px)', { noSsr: true });

  return <ChangeDetailsForm navigator={navigator} isSmallScreen={isSmallScreen} />;
}
